<template>
  <div style="width: 100vw;" :class="ISphone ? smallh2label : bigh2label">
    <img
      src="http://pic.midongtech.xyz/yytgw/assets/img_short_media_img_banner.jpg"
      style="width: 100vw;height: 20.5vw;margin-top:2px;"
    />

    <div v-if="ISphone" class="fx-column fx-row-center">
      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_short_media_img_ip_ph.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_spread_img_show_ph.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_short_media_img_show_2_ph.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_short_media_img_service_2_ph.png"
        style="width: 100vw;"
      />
    </div>
    <div v-else>
      <div class="fx-column fx-row-center" style="width:100vw; background: white;">
        <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">愉悦推IP矩阵</div>

        <div class="blueline"></div>

        <div
          class="fx-row fx-row-top fx-wrap fx-row-space-around"
          style="width: 70%; margin-bottom:5vw;"
        >
          <div
            class="fx-column fx-row-center"
            style="  margin-top:5vw; width:33%; background:white; border-radius:4px;"
            v-for="(item, index) in dataarray1"
            v-bind:key="index"
          >
            <img
              :src="item.iconurl"
              class="hvr_grow_shadow"
              style="width: 8vw;height: 8vw; margin-bottom:1vw; "
            />
            <div
              :class="ISphone ? smallh3label : 'pxlabel_20'"
              style=" font-weight:middle; width:70%; text-align:center; color:#16214B;"
            >{{ item.titlestr }}</div>
            <div
              :class="ISphone ? smallh3label : 'px_label_14'"
              style="margin-top: 1vw; width:70%; text-align:center; color:#515978;"
            >{{ item.desstr }}</div>
          </div>
        </div>
      </div>

      <img
        src="http://pic.midongtech.xyz/yytgw/assets/img_spread_bg_content_new.jpg"
        style="width: 100vw; padding:0; margin:0;"
      />

      <!--   业务  bussiness -->
      <div class="bussiness fx-column fx-row-center">
        <!-- <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">我们的业务</div>
        <div class="blueline"></div>-->

        <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">广告合作形式</div>

        <div class="blueline"></div>

        <div style="margin-top: 3vw; width: 50vw; ">愉悦推以有趣的创意和有效的落地为客户提供</div>

        <div
          class="fx-row fx-row-top fx-row-space-between"
          style="width: 90vw; margin-top: 4vw; margin-bottom: 4vw;"
        >
          <div
            class="fx-column fx-row-center"
            v-for="(item, index) in dataarray2"
            v-bind:key="index"
          >
            <img class="bussiness_icon hvr_grow_shadow" :src="item.iconurl" />
            <div
              :class="ISphone ? smallh2label : 'pxlabel_20'"
              class="bussiness_title"
            >{{ item.titlestr }}</div>
            <div
              :class="ISphone ? smallh3label : 'pxlabel_14'"
              class="bussiness_des"
              style="text-align:center;"
            >{{ item.desstr1 }}</div>
            <div
              :class="ISphone ? smallh3label : 'pxlabel_14'"
              class="bussiness_des"
              style="text-align:center;"
            >{{ item.desstr2 }}</div>
          </div>
        </div>

        <!--      21vw   24.6vw   -->
      </div>

      <div class="fx-column fx-row-center" style="width:100vw; background: white;">
        <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">服务流程</div>

        <div class="blueline"></div>

        <div
          class="fx-row fx-row-center fx-row-space-around"
          style="width: 80%;  margin-bottom: 5vw;"
        >
          <div
            class="fx-column fx-row-center fx-row-middle hvr_grow_shadow"
            style=" margin-top: 3vw; width:28%;height: 14vw; background:white; border-radius:4px; "
            v-for="(item, index) in dataarray3"
            v-bind:key="index"
            :style="{
            backgroundImage: 'url(' + item.iconurl + ')',
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat'
          }"
          >
            <div
              :class="ISphone ? smallh2label : 'pxlabel_20'"
              style="   text-align:center; color:white;font-weight: bold; "
              :style="{ width: ISphone ? '80%' : '40%' }"
            >{{ item.titlestr }}</div>
          </div>
        </div>
      </div>
    </div>
    <!--    联系我们  -->

    <contactusview />
  </div>
</template>
<script type="text/ecmascript-6">
import contactusview from "@/components/contactusview.vue";

export default {
  name: "ShortVideoPromotion",
  components: {
    contactusview
  },
  data() {
    return {
      ISphone: false,
      bigh1label: "bigh1label",
      bigh2label: "bigh2label",
      bigh3label: "bigh3label",
      smallh1label: "smallh1label",
      smallh2label: "smallh2label",
      smallh3label: "smallh3label",
      bigh4label: "bigh4label",

      dataarray1: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_common_img_short_media_ip_fir.png",
          titlestr: "母婴类IP",
          desstr: "育儿知识、英文儿歌好物推荐、育儿趣事"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_common_img_short_media_ip_sec.png",
          titlestr: "时尚类IP",
          desstr: "美妆、穿搭、健身"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_common_img_short_media_ip_thir.png",
          titlestr: "好物类IP",
          desstr: "好看、好玩、好用"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_common_img_short_media_ip_four.png",
          titlestr: "星座类IP",
          desstr: "情感、运势、星座特征"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_common_img_short_media_ip_five.png",
          titlestr: "猎奇类IP",
          desstr: "神器、恶搞"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_common_img_short_media_ip_six.png",
          titlestr: "情感类IP",
          desstr: "经典语录、好书分享"
        }
      ],

      dataarray2: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_common_img_short_media_cop_fir.png",
          titlestr: "数据咨询",
          desstr1: "方向定位、资源分配",
          desstr2: "运营策略、落地执行"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_common_img_short_media_cop_sec.png",
          titlestr: "培训课程",
          desstr1: "平台政策、内容创作",
          desstr2: "用户运营、商业变现"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_common_img_short_media_cop_thir.png",
          titlestr: "内容供给",
          desstr1: "视频拍摄、剪辑配音",
          desstr2: "背景效果、编导指导"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_common_img_short_media_cop_four.png",
          titlestr: "代理运营",
          desstr1: "人设构建、内容创作",
          desstr2: "用户运营、热点跟踪"
        }
      ],
      dataarray3: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_short_media_img_commend_fir.png",
          titlestr: "内容账号定位 内容创意策划",
          desstr: ""
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_short_media_img_commend_sec.png",
          titlestr: "视频拍摄剪辑 全网流量覆盖",
          desstr: ""
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_yshort_media_img_commend_thir.png",
          titlestr: "产品深度变现 后期运营培训",
          desstr: ""
        }
      ]
    };
  },
  mounted() {
    this.ISphone = this.$appdata.ISphone;
    let a = 123;
    console.log("TCL: mounted -> a", a);
  },
  methods: {
    /**
     * 点击事件
     */
    /**
     * 网络请求
     */
    /**
     * 业务方法
     */
    /**
     * 回调方法
     */
    /**
     * 页面私有方法
     */
  }
};
</script>
<style lang="less" scoped>
/*页面公共样式*/
.adservecell {
  width: 40vw;

  //   background: url()
  // height: 25.7vw;
}

/*头部*/

/*列表*/
</style>
